import _objectSpread from "H:/project/shadow-5.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from "vuex"; //先要引入
export default {
  name: 'App',
  computed: _objectSpread({}, mapState(['loading'])),
  mounted: function mounted() {}
};